import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  notificationRequest: ['id'],
  notificationAddRequest: ['data'],
  notificationUpdateRequest: ['data'],
  notificationDeleteRequest: ['id'],
  notificationSuccess:['data'],
  notificationFailure:['error'],
});

export const NotificationTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  error: null,
  fetching: false,
});

/* ------------- Reducers ------------- */

// we're attempting to ...
export const request = state => state.merge({fetching: true});

// we've successfully ...
export const success = (state, {data}) =>
  state.merge({fetching: false, error: null, data});

// we've had a problem ...
export const failure = (state, {error}) =>
  state.merge({fetching: false, error});


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.NOTIFICATION_REQUEST]: request,
  [Types.NOTIFICATION_ADD_REQUEST]: request,
  [Types.NOTIFICATION_UPDATE_REQUEST]: request,
  [Types.NOTIFICATION_DELETE_REQUEST]: request,
  [Types.NOTIFICATION_SUCCESS]: success,
  [Types.NOTIFICATION_FAILURE]: failure,
});